import { render } from "./accountBox.vue?vue&type=template&id=22fd67ea&ts=true"
import script from "./accountBox.vue?vue&type=script&lang=ts"
export * from "./accountBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__